module.exports = __webpack_public_path__ + "static/img/b1g.079da8b8.webp";